import {uuid} from 'uuidv4';
import {setEffectParameterValues} from 'actions/index.js';

// helper functions for saving parameters to/from json
// in effects/instruments

export function saveParameterToJson(json, name, parameter, force=false, isPreset=false) {
    // checks if parameter is complex (i.e. has modulators/automation/
    // pattern locks), and saves the json if so.
    // Otherwise, we rely on just the flat value
    let depthParameter = parameter.depthParameter;
    if (saveCondition(parameter)) {
        let jsonCopy = {... json};
        jsonCopy[name] = parameter.getJson(isPreset);
        return jsonCopy;
    }
    
    return json;
}

const saveCondition = (parameter, force) => {
    return parameter.isConnectedToAnyModulator() ||
        Object.keys(parameter.patternToValue).length > 0 ||
        Object.keys(parameter.paletteToValue).length > 0 ||
        Object.keys(parameter.stepToValue).length > 0 ||
        parameter.mixAutomation.automations.length > 0 || 
        (parameter.automations && parameter.automations.length > 0) ||
        parameter.hasMacro ||
        parameter.depthParameter ||
        parameter.isMapped ||
        parameter.higherOrdered ||
        force;
       
};

export function loadParameterFromJson(json, fieldName, parameter, sequencerEngine, isCopy, isBulk=true) {
    if (fieldName in json) {
        handleModulators(json[fieldName], parameter);
        let bulkUpdate = parameter.fromJson(json[fieldName], sequencerEngine, isCopy);
        if (isBulk) {
            return bulkUpdate;
        }

        sequencerEngine = sequencerEngine || parameter.sequencerEngine;
        if (sequencerEngine) {
            sequencerEngine.store.dispatch(
                setEffectParameterValues(bulkUpdate));
        }
    } else {
        // we must rip any mods
        parameter.disconnectFromAllModulators();

        // if we're not loading frm json then we need to atleast
        // reset the min/maxes of the parameters
        parameter.resetMinMax();
    }
    return {};
}

const handleModulators = (json, parameter) => {
    // first check if we are connected to any LFOs that ARE NOT in the json...
    let lfosToKill = parameter.lfos.filter(
        x => !json.lfos || !json.lfos.includes(x.number - 1));

    if (!json.lfos) {
        lfosToKill = parameter.lfos;
    }

    lfosToKill.forEach(lfo => parameter.disconnectFromLFO(lfo));

    let envelopesToKill = parameter.envelopes.filter(
        x => !json.envelopes || !json.envelopes.includes(x.number - 1));

    if (!json.envelopes) {
        envelopesToKill = parameter.envelopes;
    }

    envelopesToKill.forEach(env => parameter.disconnectFromEnvelope(env));
    if (parameter.keyScaling && !json.keyScaling) {
        parameter.disableKeyScaling();
    }
};

